<template>
  <div  style="width: 100%;height: 100vh; border: none">
  <iframe
      v-if="pdfUrl && !isLoading"
      :src="
        viewDraftInvoice == true && draftInvoice
          ? `data:application/pdf;base64,${draftInvoice}`
          : pdfUrl
      "
      style="width: 100%;height: 100%; border: none;"
    />
  </div>
</template>
<script>
import useInvoicePreview from './useInvoicePreview';

export default {
  setup () {
    const {
    draftInvoice,
    itemLocal,
    pdfUrl,
    previewUrl,
    fetchInvoiceHtml
  } = useInvoicePreview()


  return {
    draftInvoice,
    itemLocal,
    pdfUrl,
    previewUrl,
    fetchInvoiceHtml
  }
  },

  methods: {
    fetchData() {
      const routeParam = this.$route.params;
      this.itemLocal.uuid = routeParam.uuid
      this.itemLocal.id = routeParam.id
      this.fetchInvoiceHtml()
    }
  },
  created () {
    this.fetchData()
  },

  
}
</script>